import { Link } from 'react-router-dom';
import { CircularProgress, Stack } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';

import { Button } from '../../Button';
import { ToolboxActionsProps } from '../types';
import { getCreateButtonTestId, getDetailsButtonTestId, getEditButtonTestId } from '../utils';

export const Actions = (props: ToolboxActionsProps) => {
  const { type, linkToCreate, linkToEdit, linkToDetails, loading } = props;

  if (loading) {
    return (
      <Stack
        direction='row'
        spacing={1}
        alignItems='center'
        justifyContent='center'
        mt={2}
        sx={(theme) => ({ minHeight: theme.spacing(4) })}
      >
        <CircularProgress size={18} aria-label='Loading toolbox actions' />
      </Stack>
    );
  }

  if (!linkToCreate && !linkToEdit && !linkToDetails) return null;

  return (
    <>
      <Stack mt={2} direction='row' spacing={1}>
        {linkToCreate && (
          <Button
            component={Link}
            to={linkToCreate}
            variant='outlined'
            size='small'
            data-testid={getCreateButtonTestId(type)}
            sx={{ flex: 3 }}
          >
            +Add
          </Button>
        )}
        {linkToEdit && (
          <Button
            component={Link}
            to={linkToEdit}
            variant='outlined'
            size='small'
            data-testid={getEditButtonTestId(type)}
            sx={{ flex: 2 }}
          >
            Edit
          </Button>
        )}
        {linkToDetails && (
          <Button
            component={Link}
            to={linkToDetails}
            variant='contained'
            size='small'
            data-testid={getDetailsButtonTestId(type)}
            sx={{ flex: 1 }}
          >
            View
            <ArrowForward fontSize='small' />
          </Button>
        )}
      </Stack>
    </>
  );
};
